import { DoorFront, Favorite, Person } from "@mui/icons-material";
import LocationPinIcon from "@mui/icons-material/LocationPin";
import PhoneIcon from "@mui/icons-material/Phone";
import MobileServicesPage from "./MobileServicesPage/MobileServicesPage";
import MobilePersonelPage from "./MobilePersonelPage/MobilePersonelPage";
import MobileFacilityPage from "./MobileFacilityPage/MobileFacilityPage";
import MobileLocationPage from "./MobileLocationPage/MobileLocationPage";
import MobileContactPage from "./MobileContactPage/MobileContactPage";

export const mobilePages = [
  {
    label: "Θεραπείες",
    path: "/services",
    navicon: <Favorite />,
    component: <MobileServicesPage />,
  },
  {
    label: "Προσωπικό",
    path: "/personel",
    navicon: <Person />,
    component: <MobilePersonelPage />,
  },
  {
    label: "Ο Χώρος μας",
    path: "/facility",
    navicon: <DoorFront />,
    component: <MobileFacilityPage />,
  },
  {
    label: "Τοποθεσία",
    path: "/location",
    navicon: <LocationPinIcon />,
    component: <MobileLocationPage />,
  },
  {
    label: "Επικοινωνία",
    path: "/contact",
    navicon: <PhoneIcon />,
    component: <MobileContactPage />,
  },
];
